import React, {useEffect, useState} from "react";
import {Button, Flex, message, Space, Spin, Tag, Typography} from "antd";
import * as API_BOOKS from '../../../../../shared/http/books';
import {BookMark} from "../../../../../shared/types/api";
import {useParams} from "react-router-dom";
import {BookOutlined, ClockCircleOutlined, DeleteOutlined} from "@ant-design/icons";

interface BookmarksTabProps {
    item: BookMark;
    openBookMark: (offset: number) => void
    handleRemoveBookmark: (bookMarkId: number) => void
}

const BookmarksItem: React.FC<BookmarksTabProps> = ({item, openBookMark, handleRemoveBookmark}) => {

    const [removeLoading, setRemoveLoading] = useState<boolean>(false)

    const removeBookMark = async (bookMarkId: number) => {
       try {
           setRemoveLoading(true)
           await API_BOOKS.deleteBookmark(Number(bookMarkId), bookMarkId);
           handleRemoveBookmark(bookMarkId);
       }finally {
           setRemoveLoading(false)
       }

    };

    return (
        <Flex
            key={item.id}
            vertical
            style={{
                gap: 8,
                borderRadius: 8,
                padding: "16px 16px",
                transition: "background 0.2s ease",
                boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
            }}
        >
            <Space align="center" style={{marginBottom: 8}}>
                <ClockCircleOutlined style={{color: "#888"}}/>
                <Tag color="blue" style={{marginLeft: 4}}>
                    {item.formatedTime}
                </Tag>
            </Space>

            <Flex gap="small">
                <Button
                    size="small"
                    type="primary"
                    icon={<BookOutlined/>}
                    onClick={() => openBookMark(item.offset)}
                >
                    Перейти
                </Button>
                <Button
                    size="small"
                    danger
                    icon={<DeleteOutlined/>}
                    loading={removeLoading}
                    onClick={() => removeBookMark(item.id)}
                >
                    Удалить
                </Button>
            </Flex>
        </Flex>
    );
};

export default BookmarksItem;
